import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useCallback } from 'react'
import PageEntrance from '~components/motion/page-entrance'
import ConsultationDetail from '~containers/app/consultation-detail'
import usePopStateEventListener from '~hooks/use-pop-state-event-listener'
import useConsultationDetail from '~repositories/hooks/use-consultation-detail'
import getRootPath from '~utils/app/get-root-path'

export const Route = createFileRoute('/samsung/smart-things/(app)/consultation/$id')({
  component: RouteComponent,
  validateSearch: (search: { referrer?: 'ask-a-vet' }) => {
    return search
  },
})

function RouteComponent() {
  const router = useRouter()
  const { id } = Route.useParams()
  const { referrer } = Route.useSearch()

  useConsultationDetail({ id })

  const onPopState = useCallback(() => {
    switch (referrer) {
      case 'ask-a-vet':
        setTimeout(() => {
          router.history.replace(`${getRootPath()}/`)
        }, 100)
        break
      default:
        setTimeout(() => {
          router.history.back()
        }, 100)
    }
  }, [referrer, router.history])

  usePopStateEventListener({
    onPopState: referrer ? onPopState : undefined,
  })

  return (
    <PageEntrance>
      <ConsultationDetail id={id} />
    </PageEntrance>
  )
}
